import React from 'react'
import { Row } from '@components/layout/Form'
import { Flex, Text } from '@clear/design-system'

type StatusCardDetailsProp = {
  content1: string
  value1: string
  content2: string
  value2: string
}

export function StatusCardDetails({
  content1: heading1,
  value1,
  content2: heading2,
  value2,
}: StatusCardDetailsProp) {
  return (
    <Row
      justifyContent={['flex-start', 'space-between']}
      textAlign="center"
      width={[null, '70%', '55%']}
      mx={[0, '15%', '22.5%']}
      my={[4, 2]}
    >
      <Flex flexDirection="column" alignItems="center" my={[3, null]}>
        <Text variant="body" color="neutralsTextGray">
          {heading1}
        </Text>
        <Text
          variant="display"
          color="brandDarkBlue"
          __css={{
            textTransform: 'uppercase',
          }}
          fontSize={4}
        >
          {value1}
        </Text>
      </Flex>
      <Flex my={[3, null]} flexDirection="column" alignItems="center">
        <Text variant="body" color="neutralsTextGray">
          {heading2}
        </Text>
        <Text
          variant="display"
          color="brandDarkBlue"
          __css={{
            textTransform: 'uppercase',
          }}
          fontSize={4}
        >
          {value2}
        </Text>
      </Flex>
    </Row>
  )
}
